import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { classnames } from "../utils/text";

export const Icon = ({
  type = "",
  src,
  className,
  width,
  height,
  imageStyle,
  ...props
}) => {
  const [isSvg, setIsSvg] = useState(false);
  useEffect(() => {
    if (src) {
      setIsSvg(src.indexOf(".svg") > -1);
    }
  }, [src]);
  return (
    <span
      className={classnames("icon", className)}
      {...props}
      style={{
        ...({ width } || {}),
        ...({ height } || {}),
        ...(props?.style || {})
      }}
    >
      {isSvg ? (
        <SVG
          src={src}
          {...(width ? { width } : {})}
          {...(height ? { height } : {})}
        />
      ) : (
        <img src={src} alt={""}
          {...(width ? { width } : {})}
          {...(height ? { height } : {})}
          {...(imageStyle ? imageStyle : {})}
        />
      )}
    </span>
  );
};

export default Icon;
